import { render, staticRenderFns } from "./KeywordSearch.vue?vue&type=template&id=6876fb9c&scoped=true&"
import script from "./KeywordSearch.vue?vue&type=script&lang=js&"
export * from "./KeywordSearch.vue?vue&type=script&lang=js&"
import style0 from "./KeywordSearch.vue?vue&type=style&index=0&id=6876fb9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6876fb9c",
  null
  
)

export default component.exports